import React, { useState } from 'react';
import {
  CircularProgress,
  ClickAwayListener,
  Grid,
  InputAdornment,
  makeStyles,
  Modal,
  Tooltip,
  Drawer,
  withStyles,
  Divider,
  TableHead,
  Checkbox,
  Popper,
  Grow,
  Paper,
  MenuList,
  MenuItem,
  Box,
  TableRow,
  Card,
  CardContent,
  ButtonGroup,
  Switch
} from '@material-ui/core';
import { Button, TextField, Typography } from '@swagup-com/components';
import {
  Add,
  Remove,
  CheckCircle,
  CloseRounded,
  CloudUpload,
  DeleteOutlineRounded,
  Edit,
  Warning
} from '@material-ui/icons';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { ChromePicker } from 'react-color';
import { useDropzone } from 'react-dropzone';
import Close from '@material-ui/icons/Close';
import isEmpty from 'lodash/isEmpty';
import NumberFormat from 'react-number-format';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import DoneIcon from '@material-ui/icons/Done';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Modal as SharedModal } from '../shared/Modal';
import { Img, ImgWithHandler } from '../global/ImgUtils';
import { StandardCard } from '../shared/containers/Cards';
import styles from './styles/storefrontsHome';
import { formatDate, imageSrcSet, joinFields, moneyStr, s3, truncateFileName } from '../../helpers/utils';
import CircularCheckbox from '../pages/orders/requested/common/CircularCheckbox';
import { TableCell } from '../pages/orders/requested/shipments/TableCommon';
import { StylessButton } from '../buttons';
import Select from '../global/Select';
import TableSortBy from './TableSortBy';
import { ellipsisStyles } from '../shared/styles/commonStyles';
import { CustomTooltip } from '../products/commonProductsElements';
import EditField from '../global/EditField';
import { GreenAntSwitch } from '../account/AccountSharedComponents';
import { useQueryParams } from '../../hooks';
import { Link } from '../shared';

const useStyles = makeStyles(styles);

const getStatus = active => (active ? 'Active' : 'Inactive');
const getStatusAllowed = allow => (allow ? 'Allowed' : 'Restricted');
const prepare = text => text.toLowerCase().replaceAll(' ', '-');
const getUrlSlugParts = urlSlug => {
  const allWords = urlSlug.split('-');
  const accountId = allWords.splice(0, 1);
  const projectName = allWords.join('-');
  return { accountId, projectName };
};

const getPageLink = ({ urlSlug }) => {
  if (!urlSlug) return '/';
  const parts = getUrlSlugParts(urlSlug);
  return `${process.env.REACT_APP_STOREFRONTS_PAGES_LANDINGS}/${parts.accountId}/${parts.projectName}`;
};

const StorefrontCard = ({ store, selected, onEdit, isLoading }) => {
  const classes = useStyles(selected);
  return (
    <StandardCard className={classes.card} data-testid={`card-${store.id}`}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography variant="body4RegularInter" className={classes.storefrontType}>
                <span style={{ color: store.isActive ? '#2E7D32' : '#989EA4', fontWeight: 500 }}>
                  {getStatus(store.isActive)}
                </span>
              </Typography>
            </Grid>
            <Grid item>
              <a href={`${getPageLink(store?.accessSettings)}`} target="_blank" rel="noreferrer">
                <img
                  alt="Store-Front-Preview"
                  src="/images/storefront/store-front-preview.png"
                  srcSet={imageSrcSet('/images/storefront/store-front-preview.png')}
                  width={16}
                  height={16}
                />
              </a>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} container justifyContent="center">
          <Grid className={classes.imageContainer}>
            <Img
              src={store.seoSettings.featuredImage}
              alt={store.generalSettings.storeName}
              className={classes.designImage}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container alignItems="center">
            <Grid item xs={12}>
              <EditField
                value={store.generalSettings?.customStoreName || store.generalSettings?.storeName}
                className={classes.storefrontCardName}
                onEdit={name => onEdit(store.id, name)}
                isLoading={isLoading}
                // data-testid={`editfield-${product.id}`}
              />
            </Grid>
          </Grid>
          <Grid container alignItems="center">
            <Grid item xs={12} className={classes.dateLines}>
              <Typography variant="body3MediumInter" className={classes.pageCardDetails}>
                Date Created: <span>{formatDate(store.createdDate)}</span>
              </Typography>
              {store?.datePaused === false ? (
                <Typography variant="body3MediumInter" className={classes.pageCardDetails}>
                  Date Paused: <span>{formatDate(store.datePaused)}</span>
                </Typography>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item xs={12} style={{ marginTop: 20 }}>
            <Button
              size="small"
              variant="primary"
              component={Link}
              to={`/shop-details/${store.accessSettings.urlSlug}`}
              fullWidth
              className={classes.butonSizeSmall}
            >
              View Details
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </StandardCard>
  );
};

const ProductCard = ({ product, selected, onSelect, onSetQuanity, current }) => {
  const classes = useStyles({ selected });

  return (
    <StandardCard className={classes.productCard} data-testid={`card-${product.id}`}>
      <CircularCheckbox
        className={classes.productCheckbox}
        checked={selected}
        onChange={onSelect}
        inputProps={{ 'aria-label': product.name, 'aria-checked': selected }}
      />
      <Grid container style={{ padding: '0px 8px' }}>
        <Grid item xs={12} container justifyContent="center">
          <Grid className={classes.productImageContainer}>
            <Img src={product.image} alt={product.name} className={classes.productImage} />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2SemiBoldInter" className={classes.designName} style={{ textAlign: 'center' }}>
            {product.name}
          </Typography>
        </Grid>
        <Grid container alignItems="center">
          <Grid item xs={12}>
            <Grid container justifyContent="center">
              {product.stock
                .filter(stock => stock.quantity > 0)
                .map(stock => (
                  <Grid key={stock.size.id} item>
                    <Typography variant="body4RegularInter" style={{ color: stock.quantity ? 'inherit' : '#C6CACD' }}>
                      {`${stock.size.name}: ${stock.quantity}`}
                    </Typography>
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.quantitySection}>
        <Grid container alignItems="center">
          <Grid item style={{ height: 16 }}>
            <Button
              variant="text"
              disabled={!current?.quantity}
              style={{ height: 16 }}
              onClick={() => onSetQuanity(current, current.quantity - 1)}
            >
              <Remove className={classes.linkIcon} style={{ margin: 0 }} />
            </Button>
          </Grid>
          <Grid item xs>
            <p style={{ textAlign: 'center' }}>{current?.quantity || 0}</p>
          </Grid>
          <Grid itemstyle={{ height: 16 }}>
            <Button
              variant="text"
              disabled={!current}
              style={{ height: 16 }}
              onClick={() => onSetQuanity(current, (current?.quantity || 0) + 1)}
            >
              <Add className={classes.linkIcon} style={{ margin: 0 }} />
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </StandardCard>
  );
};

const PresetTemplate = ({ selected, onSelect, name, subtext, image }) => {
  const classes = useStyles({ selected });

  const handleKeyDown = e => {
    if (e.keyCode === 13) onSelect();
  };

  const containerProps = { role: 'button', tabIndex: 0, onClick: onSelect, onKeyDown: handleKeyDown };

  return (
    <div {...containerProps} className={classes.dataTemplate}>
      <Grid container alignItems="center">
        <Grid item>
          <div style={{ height: 54, width: 54, background: '#F5F5F6', borderRadius: 12 }}>
            <img
              src={`/images/storefront/${image}.png`}
              alt={name}
              style={{ objectFit: 'scale-down', width: '100%' }}
            />
          </div>
        </Grid>
        <Grid item xs>
          <Grid container alignItems="center" style={{ paddingLeft: 20 }}>
            <Grid item>
              <Typography variant="h6SemiBoldInter" style={{ color: '#131415' }}>
                {name}
              </Typography>
              <Typography variant="body3RegularInter" style={{ color: '#787B80' }}>
                {subtext}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid item style={{ height: 24 }}>
            {selected && <CheckCircle className={classes.checkedIcon} />}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const SelectedProductName = ({ selectedProduct }) => {
  if (isEmpty(selectedProduct)) return <p style={{ width: 56 }}>{' - '}</p>;
  return <span>{selectedProduct[0].name}</span>;
};

const SmallCheckbox = withStyles({
  root: {
    padding: 0,
    height: 14,
    width: 14,
    color: '#989EA4',
    '&$checked': { color: '#3577d4' },
    '& .MuiSvgIcon-root': {
      height: 14,
      width: 14
    }
  },
  checked: {}
})(Checkbox);

const shipmentStatuses = {
  Success: 'Success',
  Warning: 'Warning',
  Error: 'Error'
};
const getShippingStatus = status => {
  switch (status) {
    case 'Scheduled':
    case 'On Its Way':
    case 'Delivered':
    case 'Email Sent':
    case 'Approved':
      return shipmentStatuses.Success;
    case 'Out Of Stock':
    case 'Insufficient Credit':
    case 'Unexpected Error':
    case 'Unstorefronted':
    case 'Pending Approval':
      return shipmentStatuses.Warning;
    case 'Failure':
    case 'Return To Sender':
    case 'Invalid Address':
    case 'Cancelled':
    case 'Canceled':
      return shipmentStatuses.Error;
    default:
      return shipmentStatuses.Warning;
  }
};

const ShippingNote = ({ shipping, classes }) => {
  const note = ['Failure', 'On Its Way', 'Delivered'].includes(shipping.status) ? (
    <span>
      {shipping.trackingUrl && shipping.trackingNumber ? (
        <>
          See{' '}
          <a target="_blank" rel="noopener noreferrer" className={classes.link} href={shipping.trackingUrl}>
            tracking info
          </a>
        </>
      ) : (
        'No tracking available'
      )}
    </span>
  ) : (
    <>
      {shipping.status === 'Scheduled'
        ? `${
            dayjs(shipping.shippingDate).isAfter('01/01/2022')
              ? `Shipping Date: ${dayjs(shipping.shippingDate).format('MM/DD/YYYY')}`
              : ''
          }`
        : shipping.note}
    </>
  );
  return (
    <Typography variant="body4RegularInter" className={classes.shippingStatusDescription}>
      {note}
    </Typography>
  );
};

const attachedShippingNote = shipping => {
  switch (shipping.status) {
    case 'Out Of Stock':
      return 'You ran out of inventory';
    case 'Insufficient Credit':
      return 'Replenish credit to continue shipment';
    case 'Unexpected Error':
      return 'Contact customer service';
    default:
      return shipping.note;
  }
};

const attachShippingNote = shipping => ({ ...shipping, note: attachedShippingNote(shipping) });

const ShippingStatus = ({ shipping = {}, classes }) => (
  <div className={classes.shippingStatusContainer}>
    <Grid container alignItems="center">
      <Grid item>
        <div className={classes[`shipping${getShippingStatus(shipping.status || 'Cancelled')}`]} />
      </Grid>
      <Grid item xs>
        <Typography variant="body3RegularInter" className={classes.shippingStatusText}>
          {shipping.status || 'Cancelled'}
        </Typography>
      </Grid>
    </Grid>
    <Grid container alignItems="center">
      <Grid item xs style={{ paddingLeft: 18 }}>
        <ShippingNote shipping={attachShippingNote(shipping)} classes={classes} />
      </Grid>
    </Grid>
  </div>
);

export const CustomTableRow = withStyles({
  root: {
    borderBottom: '1px solid #E5E7E8',
    backgroundColor: '#ffffff',
    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.08)' },
    '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: 'rgba(53, 119, 212, 0.08) !important' }
  }
})(TableRow);

export const CustomMinimalTableRow = withStyles({
  root: {
    borderBottom: '1px solid #E5E7E8',
    backgroundColor: '#ffffff',
    '&:hover': { borderBottom: '1px solid #D6D8DB' },
    '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: 'rgba(53, 119, 212, 0.08) !important' }
  }
})(TableRow);

const ProductOptionRow = ({ product, isSelected, toogleSelectedItems, onDeleteProduct, onVisibleChanged }) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const history = useHistory();
  const location = useLocation();
  const query = useQueryParams();

  const openActionlist = e => {
    setOpen(true);
    e.stopPropagation();
  };
  const handleOnEdit = () => {
    query.set('edit-product', product.id);
    history.replace({ ...location, search: query.toString() });
  };
  const classes = useStyles();

  const ProductStatus = ({ status }) => {
    let textColor;

    switch (status) {
      case 'In Stock':
        textColor = '#4CAF50';
        break;
      case 'Low in Stock':
        textColor = '#EF6C00';
      case 'Low Stock':
        textColor = '#EF6C00';
        break;
      case 'Out of Stock':
        textColor = '#C62828';
        break;
      case 'Missing Info':
        textColor = '#B7BBBF';
        break;
      default:
        textColor = 'black';
    }

    const textStyle = {
      textTransform: 'uppercase',
      color: textColor
    };

    return (
      <Typography variant="body4MediumInter" style={textStyle}>
        {status?.replace('Low in Stock', 'Low Stock')}
      </Typography>
    );
  };

  return (
    <CustomTableRow
      onClick={() => !open && toogleSelectedItems(product)}
      onMouseLeave={() => setOpen(false)}
      className={classes.shipmentRedemptionRow}
      style={{ cursor: 'pointer', backgroundColor: isSelected && 'rgba(53, 119, 212, 0.08)' }}
    >
      <TableCell scope="row" width="16px">
        <SmallCheckbox
          className="small-checkbox"
          checked={isSelected}
          style={{ display: isSelected ? 'inherit' : 'none' }}
        />
      </TableCell>
      <TableCell>
        <GreenAntSwitch checked={product.isVisible} onChange={({ target }) => onVisibleChanged(target.checked)} />
      </TableCell>
      <TableCell>
        <img src={`${product.imageUrl}`} className={classes.productImg} alt="store-products" width={48} height={48} />
      </TableCell>
      <TableCell width="30%">
        <Grid container alignItems="center">
          <Grid item xs style={{ cursor: 'text' }}>
            <Typography variant="body3MediumInter" className={classes.nameCellText}>
              {product.name}
            </Typography>
          </Grid>
        </Grid>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body3MediumInter">{product.type}</Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body3MediumInter">{product.unitSold}</Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body4MediumInter" style={{ textTransform: 'uppercase' }}>
          <ProductStatus status={product?.status} />
        </Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <StylessButton onClick={e => openActionlist(e)}>
          <Box
            ref={anchorRef}
            className={classes.moreOptions}
            style={open ? { backgroundColor: 'rgba(53, 119, 212, 0.32)', borderRadius: '4px' } : null}
          >
            <Typography variant="body4RegularInter">•••</Typography>
          </Box>
        </StylessButton>
        <Popper open={open} anchorEl={anchorRef.current} role="menu" transition>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper className={classes.orderMenu} style={{ width: '120px' }}>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                  <MenuList autoFocusItem={open} id="menu-list-grow">
                    {/* <MenuItem className={classes.orderMenuItem} disabled={product.contactId}>
                      <Link to={`/contact-details/${product.contactId}`}>
                        <Typography variant="body4RegularInter">Product Information</Typography>
                      </Link>
                    </MenuItem> */}
                    <MenuItem onClick={handleOnEdit}>
                      <Typography variant="body4RegularInter">Edit</Typography>
                    </MenuItem>
                    <MenuItem>
                      <Link to={`/reorder/select-quantities/${product.variants[0]?.platformId}`}>
                        <Typography variant="body4RegularInter">Reorder</Typography>
                      </Link>
                    </MenuItem>
                    <MenuItem
                      onClick={() => onDeleteProduct(product.id)}
                      className={classes.orderMenuItem}
                      // disabled={product.unitSold > 0}
                    >
                      <Typography variant="body4RegularInter">Delete</Typography>
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </TableCell>
    </CustomTableRow>
  );
};

const CustomerRow = ({
  customer,
  isSelected,
  toogleSelectedItems,
  onShowOrders,
  onAddFunds,
  onChangeStatus,
  onDelete,
  isPlatinum
}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const openActionlist = e => {
    setOpen(true);
    e.stopPropagation();
  };

  const classes = useStyles();

  return (
    <CustomTableRow
      onClick={() => !open && toogleSelectedItems(customer)}
      onMouseLeave={() => setOpen(false)}
      className={classes.shipmentRedemptionRow}
      style={{ cursor: 'pointer', backgroundColor: isSelected && 'rgba(53, 119, 212, 0.08)' }}
    >
      <TableCell scope="row" width="16px">
        <SmallCheckbox
          className="small-checkbox"
          checked={isSelected}
          style={{ display: isSelected ? 'inherit' : 'none' }}
        />
      </TableCell>
      <TableCell width="30%">
        <Grid container alignItems="center">
          <Grid item xs style={{ cursor: 'text' }}>
            <Typography variant="body3MediumInter" className={classes.nameCellText}>
              {joinFields([customer.firstName, customer.lastName], ' ')}
            </Typography>
            <Typography variant="body4RegularInter" className={classes.lightText}>
              {customer.email}
            </Typography>
          </Grid>
        </Grid>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body3MediumInter">{customer.totalOrders}</Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body3MediumInter">{moneyStr(customer.totalSpend)}</Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body4MediumInter">{dayjs(customer.createdDate).format('MM/DD/YYYY')}</Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body4MediumInter">{dayjs(customer.lastActivitydDate).format('MM/DD/YYYY')}</Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body3MediumInter">{moneyStr(customer.storeCredits)}</Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <StylessButton onClick={e => openActionlist(e)}>
          <Box
            ref={anchorRef}
            className={classes.moreOptions}
            style={open ? { backgroundColor: 'rgba(53, 119, 212, 0.32)', borderRadius: '4px' } : null}
          >
            <Typography variant="body4RegularInter">•••</Typography>
          </Box>
        </StylessButton>
        <Popper open={open} anchorEl={anchorRef.current} role="menu" transition>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper className={classes.orderMenu}>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                  <MenuList autoFocusItem={open} id="menu-list-grow">
                    <MenuItem className={classes.orderMenuItem} disabled={customer.platformId}>
                      <Link to={`/contact-details/${customer.platformId}`}>
                        <Typography variant="body4RegularInter">Contact Information</Typography>
                      </Link>
                    </MenuItem>
                    {customer.totalOrders > 0 && (
                      <MenuItem className={classes.orderMenuItem} onClick={() => onShowOrders(customer.id)}>
                        <Typography variant="body4RegularInter">Customer Orders</Typography>
                      </MenuItem>
                    )}
                    <CustomTooltip
                      title="You must upgrade to Platinum in order to use this feature"
                      disableHoverListener={isPlatinum}
                    >
                      <MenuItem
                        onClick={() => onAddFunds(customer)}
                        className={classes.orderMenuItem}
                        disabled={!isPlatinum}
                      >
                        <Typography variant="body4RegularInter">Add Funds</Typography>
                      </MenuItem>
                    </CustomTooltip>
                    {/* <MenuItem
                      onClick={() => onChangeStatus(customer, customer.status === 'Banned' ? 'Activated' : 'Banned')}
                      className={classes.orderMenuItem}
                    >
                      <Typography variant="body4RegularInter">{customer.status === 'Ban' ? 'Unban' : 'Ban'}</Typography>
                    </MenuItem> */}
                    <MenuItem
                      onClick={() =>
                        onChangeStatus(customer, customer.status === 'Deactivated' ? 'Activated' : 'Deactivated')
                      }
                      className={classes.orderMenuItem}
                    >
                      <Typography variant="body4RegularInter">
                        {customer.status === 'Deactivated' ? 'Activate' : 'Deactivate'}
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      onClick={() => onDelete(customer)}
                      className={classes.orderMenuItem}
                      disabled={customer.totalOrders > 0}
                    >
                      <Typography variant="body4RegularInter">Delete</Typography>
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </TableCell>
    </CustomTableRow>
  );
};

const PayoutRow = ({ payout, isSelected, toogleSelectedItems, onShowDetails }) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const openActionlist = e => {
    setOpen(true);
    e.stopPropagation();
  };

  const classes = useStyles();

  return (
    <CustomTableRow
      onClick={() => !open && toogleSelectedItems(payout)}
      onMouseLeave={() => setOpen(false)}
      className={classes.shipmentRedemptionRow}
      style={{ backgroundColor: isSelected && 'rgba(53, 119, 212, 0.08)' }}
    >
      <TableCell scope="row" width="16px">
        <SmallCheckbox
          className="small-checkbox"
          checked={isSelected}
          style={{ display: isSelected ? 'inherit' : 'none' }}
        />
      </TableCell>
      <TableCell width="30%">
        <Grid container alignItems="center" onClick={() => onShowDetails(payout.id)}>
          <Grid item xs style={{ cursor: 'text' }}>
            <Typography
              variant="body3MediumInter"
              className={classes.nameCellText}
              style={{ color: '#3577D4', cursor: 'pointer' }}
            >
              {payout.payoutNumber}
            </Typography>
          </Grid>
        </Grid>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body3MediumInter">{moneyStr(payout.amount)}</Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body3MediumInter">{dayjs(payout.paymentDate).format('MM/DD/YYYY')}</Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography
          variant="body4MediumInter"
          style={{ color: payout.status?.toLowerCase().includes('upcoming') ? '#4CAF50' : undefined }}
        >
          {payout.status?.replace('_', ' ')}
        </Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <Typography variant="body4MediumInter">{payout.totalTiedOrders}</Typography>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        {/* <StylessButton onClick={() => onShowDetails(payout.id)}>
          <Box ref={anchorRef} className={classes.moreOptions}>
            <Typography variant="body4RegularInter">View Details</Typography>
          </Box>
        </StylessButton> */}
        {/* <Popper open={open} anchorEl={anchorRef.current} role="menu" transition>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper className={classes.orderMenu}>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                  <MenuList autoFocusItem={open} id="menu-list-grow">
                    <MenuItem onClick={() => onShowDetails(payout.id)} className={classes.orderMenuItem}>
                        <Typography variant="body4RegularInter">View Details</Typography>
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper> */}
      </TableCell>
    </CustomTableRow>
  );
};

const OrderOptionRow = ({
  classes,
  order,
  isSelected,
  toogleSelectedItems,
  onRetryShipment,
  onDeleteRedemption,
  onCancelShipment,
  onShowOrderDetails,
  selectedShipmentStatus = [],
  triggerCopyNotifications,
  uniqueUrl,
  exportAction,
  hideMenu
}) => {
  const [open, setOpen] = React.useState(false);
  const [copyNotification, setCopyNotification] = useState('Click to copy');
  const anchorRef = React.useRef(null);

  const isUnstorefronted = order.customerInformation.platformId < 0;
  const disableRetry =
    isUnstorefronted ||
    order.shippingInformation?.platformId > 0 ||
    order.orderStatus === 'Refunded' ||
    order.orderStatus === 'Canceled';
  const disableViewShipmentDetails = false; // order.shippingInformation?.shipment?.shipmentId < 1;
  // const disableDelete = order.shippingInformation?.shipment?.shipmentId > 0;
  const disableCancel =
    !['Pending Production', 'Scheduled', 'Out Of Stock', 'Insufficient Credit'].includes(
      order.shippingInformation?.shipment?.status
    ) ||
    order.orderStatus === 'Refunded' ||
    order.payoutId > 0;

  const showWarningSign = ['Out Of Stock', 'Insufficient Credit', 'Unexpected Error'].includes(
    order.shippingInformation?.shipment?.status
  );

  const isFailed = id => {
    return !!selectedShipmentStatus.find(i => i.failedRedemptionId === id);
  };
  const openActionlist = e => {
    setOpen(true);
    e.stopPropagation();
  };

  const copyToClipboard = e => {
    navigator.clipboard.writeText(uniqueUrl);
    if (open) {
      triggerCopyNotifications('Link copied to clipboard');
      setOpen(false);
    } else setCopyNotification('Link copied to clipboard');

    setTimeout(() => {
      setCopyNotification('Click to copy');
    }, 3000);

    e.stopPropagation();
  };

  const background = open || isSelected ? 'rgba(53, 119, 212, 0.08)' : undefined;

  const orderMenu = [
    {
      text: 'Order details',
      action: () => onShowOrderDetails(order.id),
      disabled: disableViewShipmentDetails
    },
    {
      text: 'Cancel Order',
      tooltip:
        order.payoutId > 0
          ? 'Order already associated with a payout. In order to cancel it contact your AE.'
          : undefined,
      action: () => {
        onCancelShipment(order);
        setOpen(false);
      },
      disabled: disableCancel
    },
    {
      text: 'Retry Order',
      action: () => {
        onRetryShipment(order);
        setOpen(false);
      },
      disabled: disableRetry
    }
  ];

  return (
    <CustomTableRow
      onClick={() => !open && toogleSelectedItems(order)}
      onMouseLeave={() => setOpen(false)}
      className={classes.shipmentRedemptionRow}
      style={{
        background: isFailed(order.id) ? '#FFCDD2' : background,
        cursor: 'pointer'
      }}
    >
      <TableCell scope="row" width="16px">
        <SmallCheckbox
          className="small-checkbox"
          checked={isSelected}
          style={{ display: isSelected ? 'inherit' : 'none' }}
        />
      </TableCell>
      <TableCell className={classes.cellLeft}>{order.orderNumber}</TableCell>
      <TableCell style={{ position: 'relative', overflowX: 'visible' }}>
        <Grid container alignItems="center">
          <Grid item style={{ height: 12 }}>
            {showWarningSign && <Warning className={classes.warningSign} />}
          </Grid>
          <Grid item xs style={{ cursor: 'text' }}>
            <Typography variant="body3MediumInter">{`${joinFields(
              [order.customerInformation.firstName, order.customerInformation.lastName],
              ' '
            )}`}</Typography>
            <Typography variant="body4RegularInter" className={classes.lightText}>
              {order.customerInformation.emailAddress}
            </Typography>
          </Grid>
        </Grid>
      </TableCell>
      <TableCell className={classes.cellCentered}>
        <ShippingStatus
          shipping={{
            ...(order.shippingInformation.shipment || {}),
            note: isUnstorefronted ? (
              <span>
                Download <StylessButton onClick={exportAction}>CSV</StylessButton>
              </span>
            ) : (
              order.shippingInformation.shipment?.note
            )
          }}
          classes={classes}
        />
      </TableCell>
      <TableCell className={classes.cellCentered}>
        {moneyStr(
          order.paymentInformation.amount + order.paymentInformation.shipmentAmount + order.paymentInformation.taxAmount
        )}
      </TableCell>
      <TableCell className={classes.cellCentered} style={{ ...ellipsisStyles, maxWidth: '282px' }}>
        {order.paymentInformation.itemsAmount}
      </TableCell>
      <TableCell className={classes.cellCentered}>
        {order.orderedDate ? formatDate(order.orderedDate) : 'XX/XX/XX'}
      </TableCell>
      <TableCell className={classes.cellCentered}>
        {!hideMenu && (
          <>
            <StylessButton onClick={e => openActionlist(e)}>
              <Box
                ref={anchorRef}
                className={classes.moreOptions}
                style={open ? { backgroundColor: 'rgba(53, 119, 212, 0.32)', borderRadius: '4px' } : null}
              >
                <Typography variant="body4RegularInter">•••</Typography>
              </Box>
            </StylessButton>
            <Popper open={open} anchorEl={anchorRef.current} role="menu" transition>
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                >
                  <Paper className={classes.orderMenu}>
                    <ClickAwayListener onClickAway={() => setOpen(false)}>
                      <MenuList autoFocusItem={open} id="menu-list-grow">
                        <MenuItem className={classes.orderMenuItem} disabled={isUnstorefronted}>
                          <Link to={`/contact-details/${order.customerInformation.platformId}`}>
                            <Typography variant="body4RegularInter">Recipient Information</Typography>
                          </Link>
                        </MenuItem>
                        {orderMenu.map(({ text, action, disabled, tooltip }) => (
                          <MenuItem key={text} className={classes.orderMenuItem} disabled={disabled} onClick={action}>
                            <CustomTooltip title={tooltip} disableHoverListener={!!tooltip}>
                              <Typography variant="body4RegularInter">{text}</Typography>
                            </CustomTooltip>
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </>
        )}
      </TableCell>
    </CustomTableRow>
  );
};

const OrderRow = ({
  order,
  customAction,
  onRetryShipment,
  onDeleteRedemption,
  toogleSelectedItems,
  onCancelShipment,
  onShowOrderDetails,
  isSelected,
  selectedShipmentStatus,
  triggerCopyNotifications,
  uniqueUrl,
  exportAction,
  hideMenu
}) => {
  const classes = useStyles();
  return (
    <OrderOptionRow
      classes={classes}
      order={order}
      customAction={customAction}
      onRetryShipment={onRetryShipment}
      toogleSelectedItems={toogleSelectedItems}
      onCancelShipment={onCancelShipment}
      onShowOrderDetails={onShowOrderDetails}
      onDeleteRedemption={onDeleteRedemption}
      isSelected={isSelected}
      selectedShipmentStatus={selectedShipmentStatus}
      triggerCopyNotifications={triggerCopyNotifications}
      uniqueUrl={uniqueUrl}
      exportAction={exportAction}
      hideMenu={hideMenu}
    />
  );
};

const TableEmptyState = ({ isSearching, type = 'order', customSubtext }) => {
  const classes = useStyles();
  return (
    <Grid container direction="column" justifyContent="center" alignItems="center" className={classes.emptyContainer}>
      <div className={classes.tableEmptyStateImage}>
        <img
          src="/images/storefront/home-empty.png"
          srcSet={imageSrcSet('/images/storefront/home-empty.png')}
          className={classes.emptyImg}
          alt="No orders found"
        />
      </div>
      <Typography variant="h5SemiBoldInter" className={classes.emptytitle}>
        {isSearching ? `No ${type}s found` : `You have no ${type}s yet`}
      </Typography>
      <Typography variant="body1RegularInter" className={classes.emptySubtitle}>
        {isSearching
          ? `Remove filters to see all the ${type}s.`
          : customSubtext || 'Invite new customers to your store by adding them here.'}
      </Typography>
    </Grid>
  );
};

const TableHeaderCollection = ({ classes }) => (
  <TableHead>
    <CustomTableRow>
      <TableCell scope="row" width="30%">
        NAME
      </TableCell>
      <TableCell className={classes.cellCentered} width="30%">
        PRODUCT SELECTED
      </TableCell>
      <TableCell className={classes.cellCentered}>SIZE</TableCell>
      <TableCell className={classes.cellCentered}>
        <Grid container alignItems="center">
          <Grid item xs={2} />
          <Grid item xs>
            DATE ADDED
          </Grid>
          <Grid item xs={2}>
            <TableSortBy />
          </Grid>
        </Grid>
      </TableCell>
      <TableCell className={classes.cellCentered}>ACTION</TableCell>
    </CustomTableRow>
  </TableHead>
);

const TableHeaderOrder = ({ classes, toogleSelectAll, allSelected }) => (
  <TableHead>
    <CustomTableRow>
      <TableCell scope="row" width="16px">
        <SmallCheckbox checked={allSelected} onChange={toogleSelectAll} />
      </TableCell>
      <TableCell className={classes.cellLeft} scope="row">
        ORDER NUMBER
      </TableCell>
      <TableCell scope="row" width="25%">
        NAME
      </TableCell>
      <TableCell width="25%">SHIPPING STATUS</TableCell>
      <TableCell className={classes.cellCentered}>ORDER COST</TableCell>
      <TableCell className={classes.cellCentered}>ITEMS</TableCell>
      <TableCell className={classes.cellCentered}>
        <Grid container alignItems="center" style={{ minWidth: 116 }}>
          <Grid item xs={2} />
          <Grid item xs>
            DATE PLACED
          </Grid>
          <Grid item>
            <TableSortBy />
          </Grid>
        </Grid>
      </TableCell>
      <TableCell scope="row" width="32px" />
    </CustomTableRow>
  </TableHead>
);

const TableHeaderProduct = ({ classes, toogleSelectAll, allSelected }) => (
  <TableHead>
    <CustomTableRow>
      <TableCell scope="row" width="16px">
        <SmallCheckbox checked={allSelected} onChange={toogleSelectAll} />
      </TableCell>
      <TableCell width="auto">VISIBILITY</TableCell>
      <TableCell width="auto">IMAGE</TableCell>
      <TableCell scope="row" width="25%">
        NAME
      </TableCell>
      <TableCell className={classes.cellCentered} width="auto">
        TYPE
      </TableCell>
      <TableCell className={classes.cellCentered} width="auto">
        UNITS SOLD
      </TableCell>
      <TableCell className={classes.cellCentered} align="center" width="auto">
        STATUS
      </TableCell>
      <TableCell className={classes.cellCentered} align="center" width="auto">
        ACTIONS
      </TableCell>
      <TableCell scope="row" width="32px" />
    </CustomTableRow>
  </TableHead>
);

const TableHeaderCustomer = ({ classes, toogleSelectAll, allSelected }) => (
  <TableHead>
    <CustomTableRow>
      <TableCell scope="row" width="16px">
        <SmallCheckbox checked={allSelected} onChange={toogleSelectAll} />
      </TableCell>
      <TableCell scope="row" width="25%">
        NAME
      </TableCell>
      <TableCell className={classes.cellCentered} width="auto">
        NUMBER OF ORDERS
      </TableCell>
      <TableCell className={classes.cellCentered} width="auto">
        TOTAL SPEND
      </TableCell>
      <TableCell className={classes.cellCentered} align="center" width="auto">
        <Grid container alignItems="center" style={{ minWidth: 130 }}>
          <Grid item xs={2} />
          <Grid item xs>
            DATE ADDED
          </Grid>
          <Grid item>
            <TableSortBy />
          </Grid>
        </Grid>
      </TableCell>
      <TableCell className={classes.cellCentered} align="center" width="auto">
        <Grid container alignItems="center" style={{ minWidth: 130 }}>
          <Grid item xs={2} />
          <Grid item xs>
            LAST ACTIVITY
          </Grid>
          <Grid item>
            <TableSortBy />
          </Grid>
        </Grid>
      </TableCell>
      <TableCell width="auto">SHOP CREDIT BALANCE</TableCell>
      <TableCell scope="row" width="32px">
        ACTION
      </TableCell>
    </CustomTableRow>
  </TableHead>
);

const TableHeaderPayout = ({ classes, toogleSelectAll, allSelected }) => (
  <TableHead>
    <CustomTableRow>
      <TableCell scope="row" width="16px">
        <SmallCheckbox checked={allSelected} onChange={toogleSelectAll} />
      </TableCell>
      <TableCell scope="row" width="25%">
        PAYOUT NUMBER
      </TableCell>
      <TableCell className={classes.cellCentered} width="auto">
        TOTAL PAYOUT
      </TableCell>
      <TableCell className={classes.cellCentered} width="auto">
        PAYMENT DATE
      </TableCell>
      <TableCell className={classes.cellCentered} align="center" width="auto">
        STATUS
      </TableCell>
      <TableCell className={classes.cellCentered} align="center" width="auto">
        NUMBER OF TIED ORDERS
      </TableCell>
      <TableCell scope="row" width="32px" />
    </CustomTableRow>
  </TableHead>
);

const CustomTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      '& input': {
        padding: '14px 16px',
        fontFamily: 'Helvetica'
      },
      '& fieldset': {
        border: '1px solid #D6D8DB',
        borderRadius: 12
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #3577D4'
      }
    }
  }
})(TextField);

const CustomSlimTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      miWidth: 90,
      height: 42,
      '& #start-adornment': {
        color: '#374151',
        fontSize: 14,
        marginBottom: -2
      },
      '& input': {
        padding: '8px 10px',
        fontFamily: 'Inter'
      },
      '& fieldset': {
        border: '1px solid #D6D8DB',
        borderRadius: 12
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #3577D4'
      }
    }
  }
})(TextField);

const CustomSlimTextFieldThin = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      padding: '8px 8px',
      borderRadius: 10,
      '& #start-adornment': {
        color: '#374151',
        fontSize: 14,
        marginBottom: -2
      },
      '& input': {
        padding: '4px 6px',
        fontFamily: 'Inter',
        background: 'transparent'
      },
      '& textarea': {
        padding: '4px 6px',
        fontFamily: 'Inter',
        textAlign: 'justify',
        fontSize: 14,
        fontWeight: 400
      },
      '& fieldset': {
        border: '1px solid #D6D8DB',
        borderRadius: 10
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #3577D4'
      }
    }
  }
})(TextField);

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      isNumericString
      decimalScale={2}
      allowNegative={false}
      isAllowed={({ value }) => value.charAt(0) !== '0' && value.charAt(0) !== '.'}
    />
  );
});

const useModalStyles = makeStyles({
  text: {
    fontFamily: 'Gilroy-SemiBold',
    marginTop: 56,
    marginBottom: 24,
    textAlign: 'center',
    color: '#0b1829',
    fontSize: 24
  },
  subtitle: {
    fontFamily: 'Gilroy',
    color: '#0b1829',
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 56
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'transparent',
    padding: 32
  },
  modalContent: {
    position: 'relative',
    padding: '32px 45px 36px 45px',
    borderRadius: 32,
    width: 520,
    backgroundColor: '#fafafa',
    outline: 'none',
    border: 'transparent'
  },
  deleteRedemptioModal: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    border: 'transparent',
    padding: 0
  },
  deleteRedemptioModalContent: {
    position: 'relative',
    padding: 0,
    borderRadius: 8,
    width: 600,
    backgroundColor: '#ffffff',
    outline: 'none',
    border: 'transparent'
  },
  deleteRedemptioModalInfoSection: {
    padding: 24
  },
  deleteRedemptioModalActionSection: {
    padding: '12px 24px',
    borderTop: '1px solid #E5E7E8'
  },
  deleteRedemptioModalInfoText: { marginTop: 16 },
  shareModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    border: 'transparent',
    padding: 32,
    paddingTop: 212
  },
  shareModalContent: {
    position: 'relative',
    padding: 0,
    borderRadius: 8,
    width: 488,
    backgroundColor: '#fafafa',
    outline: 'none',
    border: 'transparent',
    paddingBottom: 12
  },
  copyLink: {
    color: '#3577d4',
    paddingLeft: 0,
    height: 40,
    '& p': {
      color: '#3577d4',
      marginTop: 2,
      marginLeft: 4
    },
    '&:hover': {
      '& p': {
        textDecoration: 'underline'
      }
    },
    '&:focus': {
      '& p': {
        textDecoration: 'underline'
      }
    },
    '&:active': {
      color: '#1C4783',
      '& p': {
        color: '#1C4783'
      }
    },
    '&:disabled': {
      color: '#B7BBBF',
      '& p': {
        color: '#B7BBBF'
      }
    }
  },
  shareModalInfo: {
    width: '100%',
    padding: 24,
    paddingBottom: 32,
    borderBottom: '1px solid #E8EEF4'
  },
  shareModalActions: {
    width: '100%',
    padding: '12px 24px',
    paddingBottom: 2
  },
  shareModalProjectName: {
    paddingBottom: 2
  },
  notification: {
    border: '1px solid #4CAF50',
    background: '#E8F5E9',
    borderRadius: 4,
    padding: '6px 12px',
    paddingBottom: 2
  },
  notificationIcon: {
    color: '#2E7D32'
  },
  notificationText: {
    marginBottom: 4,
    marginLeft: 4
  }
});

const StorefrontDeleteModal = ({ open, onClose, onDelete }) => {
  const classes = useModalStyles();

  return (
    <Modal title="Redemption Delete Modal" open={open} onClose={onClose} className={classes.modal}>
      <Grid container direction="column" alignItems="center" className={classes.modalContent}>
        <Grid item>
          <p className={classes.text}>Are you sure you want to delete this SwagDrop?</p>
          <p className={classes.subtitle}>This action will remove also the associated landing page.</p>
        </Grid>
        <Grid item>
          <Button size="small" variant="alert" onClick={onDelete} style={{ width: 256 }}>
            Delete SwagDrop
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

const RedemptionDeleteModal = ({ open, onClose, onDelete, order = {}, type = 'order' }) => {
  const classes = useModalStyles();
  const getRedemtionName = () => {
    const sampeRedemtion = order[0] || order;
    if (_.isArray(order) && order.length > 1) return `${type}s`;
    return joinFields([sampeRedemtion.firstName, sampeRedemtion.lastName], ' ');
  };

  return (
    <Modal open={open} onClose={onClose} className={classes.deleteRedemptioModal}>
      <Grid container className={classes.deleteRedemptioModalContent}>
        <Grid item xs={12} className={classes.deleteRedemptioModalInfoSection}>
          <Typography variant="body2SemiBoldInter">{`Delete ${getRedemtionName()}?`}</Typography>
          <Typography variant="body3RegularInter" className={classes.deleteRedemptioModalInfoText}>
            {_.isArray(order) && order.length > 1
              ? `You cannot restore deleted ${type}s`
              : `You cannot restore a deleted ${type}`}
            .
          </Typography>
        </Grid>
        <Grid item xs={12} container justifyContent="flex-end" className={classes.deleteRedemptioModalActionSection}>
          <Grid item>
            <Button size="small" variant="text" onClick={onClose} style={{ width: 84, marginRight: 8 }}>
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button size="small" variant="primary" onClick={onDelete} style={{ width: 84 }}>
              Delete
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

const Notification = ({ show, message, classes }) =>
  show && (
    <Grid container alignItems="center" className={classes.notification}>
      <Grid item>
        <CheckCircle className={classes.notificationIcon} />
      </Grid>
      <Grid item>
        <Typography variant="body3MediumInter" className={classes.notificationText}>
          {message}
        </Typography>
      </Grid>
    </Grid>
  );

const getFileName = src => src?.substring(src.lastIndexOf('/') + 1);

const ImageSelector = ({
  imageName,
  selected,
  onSelect,
  url,
  artworkLoader,
  property,
  additionalProperty,
  handleFileUpload
}) => {
  const classes = useStyles({ selectedDefaultLogo: selected });
  return (
    <>
      {selected && (
        <Grid container alignItems="center" className={classes.logoSelector} onClick={() => onSelect(selected)}>
          <Grid item xs>
            <Typography variant="body3RegularInter" className={classes.lsImageName}>
              {truncateFileName(getFileName(imageName), 40)}
            </Typography>
          </Grid>
          <Grid item style={{ height: 20 }}>
            <CloseRounded className={classes.closeIcon} />
          </Grid>
        </Grid>
      )}
      <div>
        <ImageUploadSection
          classes={classes}
          artworkLoader={artworkLoader}
          url={url}
          property={property}
          additionalProperty={additionalProperty}
          handleFileUpload={handleFileUpload}
          selected={selected}
        />
      </div>
    </>
  );
};

const SimpleTooltip = withStyles(() => ({
  tooltip: {
    padding: 0,
    pointerEvents: 'all',
    boxShadow: 'none',
    margin: '0px 0px 2px 0px'
  }
}))(Tooltip);

const RedeemCustomSelectField = withStyles({
  root: {
    '& fieldset': { borderRadius: 12 }
  }
})(props => <Select {...props} />);

const ColorInput = ({ value, onChange, inputClass }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = () => {
    setDisplayColorPicker(prev => !prev);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  return (
    <SimpleTooltip
      placement="top-start"
      open={displayColorPicker}
      title={
        <ClickAwayListener onClickAway={handleClose}>
          <ChromePicker color={value} onChange={color => onChange(color.hex)} />
        </ClickAwayListener>
      }
    >
      <div>
        <CustomTextField
          size="small"
          value={value}
          onChange={({ target }) => onChange(target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" onClick={handleClick} style={{ marginRight: '0px' }}>
                <div
                  style={{
                    height: 16,
                    width: 16,
                    borderRadius: 8,
                    border: '1px solid #E5E7E8',
                    cursor: 'pointer',
                    background: value
                  }}
                />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <Edit onClick={handleClick} style={{ height: 16, width: 16, cursor: 'pointer' }} />
              </InputAdornment>
            )
          }}
          className={inputClass}
        />
      </div>
    </SimpleTooltip>
  );
};

const FeaturedLink = ({ to, disabled, children, className }) =>
  disabled ? (
    <div>{children}</div>
  ) : (
    <Link to={to} className={className}>
      {children}
    </Link>
  );

const CreateRedeemOption = ({ image, header, text, classes, option, disabled }) => (
  <FeaturedLink to={`/storefront-pages-create?option=${option}`} disabled={disabled} className={classes.linkCreate}>
    <Grid
      container
      alignItems="center"
      className={disabled ? classes.createRedeemOptionDisabled : classes.createRedeemOption}
    >
      <Grid item className={classes.croImageContainer}>
        <img src={image} alt={header} className={classes.createRedeemOptionImage} />
      </Grid>
      <Grid item xs className={classes.croContent}>
        <Typography variant="h6SemiBoldInter" style={{ color: disabled ? '#989EA4' : undefined }}>
          {header}
        </Typography>
        <Typography
          variant="body2RegularInter"
          className={classes.croContentText}
          style={{ color: disabled ? '#B7BBBF' : undefined }}
        >
          {text}
        </Typography>
      </Grid>
    </Grid>
  </FeaturedLink>
);

const CreateRedeemOptionsDrawer = ({ open, onClose, classes }) => (
  <Drawer anchor="right" open={open} onClose={onClose} classes={{ paper: classes.createRedeemBar }}>
    <Grid container justifyContent="flex-start">
      <Grid item>
        <Close className={classes.closeDrawer} onClick={onClose} />
      </Grid>
    </Grid>
    <Grid container className={classes.crDrawerContent}>
      <Grid item>
        <Typography variant="h5SemiBoldInter" className={classes.createRedeemOptionTitle}>
          Select a storefront page
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CreateRedeemOption
          option="collection"
          image="/images/storefront/collection.png"
          header="Collection"
          text="Gather contact and sizing information about your recipients. Often used before placing your swag order."
          classes={classes}
        />
        <CreateRedeemOption
          option="auto-ship"
          image="/images/storefront/auto-ship-on.png"
          header="Autoship"
          text="Automatically ship products from your inventory to recipients once they fill out their information. Often used after you have placed an order."
          classes={classes}
        />
      </Grid>
      <Grid item>
        <Typography variant="body3RegularInter" className={classes.disclaimerTitleText}>
          *Must have product(s) in your inventory in order to launch autoship.
        </Typography>
      </Grid>
    </Grid>
  </Drawer>
);

const ProductSquare = ({ product, onDelete, onAdd, classes }) => {
  const customAdd = ({ target }) => target.id === 'square-container' && onAdd();
  return (
    <Grid item xs={3}>
      <Grid container justifyContent="center">
        <Grid item>
          <StylessButton onClick={customAdd}>
            <div className={classes.productSquareImageContainer}>
              <div id="square-container" className="product-square-image-container-hover">
                <StylessButton onClick={() => onDelete(product)} className={classes.deleteProduct}>
                  <div className={classes.deleteProductIcon}>
                    <DeleteOutlineRounded />
                  </div>
                </StylessButton>
              </div>

              <ImgWithHandler
                src={product.imageUrl}
                width={256}
                height={256}
                alt={product.name}
                className={classes.productSquareImage}
              />
            </div>
          </StylessButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

const AddProductSquare = ({ classes, onAdd }) => (
  <Grid item xs={3}>
    <Grid container justifyContent="center">
      <Grid item>
        <StylessButton onClick={onAdd}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            onAdd={onAdd}
            className={classes.addProductSquare}
          >
            <Grid item>
              <Add />
            </Grid>
          </Grid>
        </StylessButton>
      </Grid>
    </Grid>
  </Grid>
);

const ProductsSelectionPanel = ({ products, onAdd, onDelete, limit, classes }) => (
  <Grid container justifyContent="center" className={classes.productsSelectionPanel}>
    <Grid item xs={12}>
      <Grid container spacing={2}>
        {products.map(product => (
          <ProductSquare key={product.id} product={product} onDelete={onDelete} onAdd={onAdd} classes={classes} />
        ))}
        {products.length < limit && <AddProductSquare classes={classes} onAdd={onAdd} />}
      </Grid>
    </Grid>
  </Grid>
);

const FileUploadZone = ({
  handleFileUpload,
  children,
  disabled,
  accept = { 'image/*': ['.gif', '.jpg', '.jpeg', '.png', '.svg'] },
  renderComponent
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleFileUpload,
    accept,
    maxSize: 5000000,
    multiple: false
  });
  return (
    <div {...getRootProps()} style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <input {...getInputProps()} disabled={disabled} />
      {renderComponent ? renderComponent({ isDragActive }) : children}
    </div>
  );
};

const ImageUploadSection = ({
  classes,
  url,
  handleFileUpload,
  property,
  additionalProperty,
  artworkLoader,
  selected
}) => {
  const [error, setError] = useState(false);
  const handleBorder = () => {
    if (error) return '1px dashed #F44336';
    if (selected) return '1px dashed #cdcfd5 &:hover';
    return undefined;
  };
  const RenderedImage = () =>
    url ? (
      <div style={{ width: 56, height: 48, position: 'relative  ' }}>
        <img src={url} alt={property} style={{ objectFit: 'contain', height: '100%', maxWidth: '100%' }} />
      </div>
    ) : (
      <CloudUpload style={{ width: 48, height: 32, color: '#3577d4' }} />
    );

  return (
    <FileUploadZone
      handleFileUpload={async files => setError(await handleFileUpload(files, property, additionalProperty))}
    >
      <div className={classes.uploadRegion} style={{ border: handleBorder() }}>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={3}>
            <Grid container justifyContent="center">
              <Grid item>
                {artworkLoader.includes(property) ? (
                  <CircularProgress style={{ float: 'left', width: 32, height: 32, marginLeft: 16 }} />
                ) : (
                  <RenderedImage />
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={9}>
            <Grid container justifyContent="center">
              <Grid item>
                <Typography variant="subtitle3SemiBoldInter" className={classes.dragDrop}>
                  Drag and drop to upload or <span>choose file</span>
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body4RegularInter" className={classes.preferedImageTypes}>
                  Accepted file types: .PNG, .GIF, .JPEG, .JPG, .SVG
                </Typography>
                <Typography variant="body4RegularInter" className={classes.preferedImageTypes}>
                  Max file size: 5MB
                </Typography>
                {error && (
                  <Typography variant="body4RegularInter" className={classes.preferedImageError}>
                    Your file could not be uploaded. Please check the accepted file types and file size and try again
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </FileUploadZone>
  );
};

const Accordion = withStyles({
  root: {
    border: 'none',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 0,
      padding: 0
    }
  },
  content: {
    display: 'block',
    '&$expanded': {
      margin: 0
    }
  },
  expanded: {
    margin: 0,
    padding: 0
  }
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    minHeight: 56,
    margin: 0,
    padding: 0,
    '&$expanded': {
      minHeight: 56,
      margin: 0,
      padding: 0
    }
  },
  content: {
    display: 'block',
    margin: 0,
    padding: 0,
    '&$expanded': {
      margin: 0
    }
  },
  expanded: {
    margin: 0,
    padding: 0
  }
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: 0
  }
})(MuiAccordionDetails);

const PageRedemptionsBlock = ({ classes, totalRedemptions }) => (
  <Grid container className={classes.pageRedemptionsBlock} alignItems="center">
    <Grid item>
      <Typography variant="body2RegularInter" className={classes.recipientsRedeemedTotal}>
        Requested Orders
      </Typography>
      <Typography variant="body2SemiBoldInter" className={classes.recipientsRedeemedTotal}>
        {totalRedemptions}
      </Typography>
    </Grid>
  </Grid>
);

const PageInventoryBlock = ({ classes, totalProducts, onViewDetails }) => (
  <Grid container className={classes.pageInventoryBlock} alignItems="center">
    <Grid item style={{ paddingRight: 16 }}>
      <Typography variant="body2RegularInter" className={classes.recipientsRedeemedTotal}>
        Inventory
      </Typography>
      <Typography variant="body2SemiBoldInter" className={classes.recipientsRedeemedTotal}>
        {totalProducts} Products
      </Typography>
    </Grid>
    <Divider orientation="vertical" style={{ height: 52 }} />
    <Grid item style={{ paddingLeft: 16 }}>
      <StylessButton onClick={onViewDetails}>
        <Typography variant="body2MediumInter" className={classes.historyLink}>
          View Details
        </Typography>
      </StylessButton>
    </Grid>
  </Grid>
);

const AvailableCreditBlock = ({ classes, creditBalance, onReload }) => (
  <Grid container className={classes.availableCreditBlock} alignItems="center">
    <Grid item>
      <div className={classes.cardImgContainer}>
        <img src="/images/storefront/card.png" alt="card" className={classes.cardImage} />
      </div>
    </Grid>
    <Grid item xs style={{ paddingRight: 16 }}>
      <Grid container justifyContent="center">
        <Grid item>
          <Typography variant="body2RegularInter" className={classes.recipientsRedeemedTotal}>
            Credit Balance
          </Typography>
          <Typography variant="body2SemiBoldInter" className={classes.recipientsRedeemedTotal}>
            {moneyStr(creditBalance)}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
    <Divider orientation="vertical" style={{ height: 52 }} />
    <Grid item style={{ paddingLeft: 16 }}>
      <StylessButton onClick={onReload}>
        <Typography variant="body2MediumInter" className={classes.historyLink}>
          Reload
        </Typography>
      </StylessButton>
    </Grid>
  </Grid>
);

const ShareStatusBlock = ({ classes, isActive }) => (
  <Grid container className={classes.shareStatusBlock} justifyContent="center" alignItems="center">
    <Grid item>
      <Typography variant="body2RegularInter" className={classes.recipientsRedeemedTotal}>
        Status
      </Typography>
      <Typography variant="body2SemiBoldInter" style={{ color: isActive ? '#2E7D32' : '#989EA4' }}>
        {getStatus(isActive)}
      </Typography>
    </Grid>
  </Grid>
);

const prepareArtworksOnS3 = async artwork => {
  const s3Data = await s3
    .upload({
      Key: `${Date.now()}-${artwork.name.replaceAll(' ', '-').replaceAll('_', '-')}`,
      Body: artwork,
      ContentType: artwork.type
    })
    .promise();
  return { name: artwork.name, url: s3Data.Location };
};

const sortObjectProperties = obj => {
  if (isEmpty(obj)) return obj;
  // Get the keys (properties) of the object and sort them alphabetically
  const sortedKeys = Object.keys(obj).sort();

  // Use Array.reduce() to create a new object with sorted properties
  const sortedObj = sortedKeys.reduce((acc, key) => ({ ...acc, [key]: obj[key] }), {});

  return sortedObj;
};

const getChangedProperties = (objA, objB) => {
  if (isEmpty(objA)) return objB;

  const changedProperties = {};

  // Check keys in objA
  Object.keys(objB || {}).forEach(key => {
    const currentPath = key;

    // If key exists in objB
    if (objB.hasOwnProperty(key)) {
      if (Array.isArray(objA[key]) && Array.isArray(objB[key])) {
        // If values are arrays, compare the arrays
        if (JSON.stringify(objA[key]) !== JSON.stringify(objB[key])) {
          const arrayA = objA[key];
          const arrayB = objB[key];
          const resultArray = [];

          arrayA.forEach(a => {
            const b = arrayB.find(bObj => bObj.id === a.id);
            if (JSON.stringify(sortObjectProperties(a)) !== JSON.stringify(sortObjectProperties(b))) {
              const bDiff = getChangedProperties(a, b);
              resultArray.push(!isEmpty(bDiff) ? { id: b.id, ...bDiff } : { id: a.id, delete: true });
            }
          });

          arrayB.forEach(b => {
            const a = arrayA.find(aObj => aObj.id === b.id);
            if (!a) {
              resultArray.push(b);
            }
          });

          changedProperties[currentPath] = resultArray;
        }
      } // If value is an object, recursively check its properties
      else if (typeof objA[key] === 'object' && typeof objB[key] === 'object') {
        const nestedChanges = getChangedProperties(objA[key], objB[key]);
        if (nestedChanges && Object.keys(nestedChanges).length > 0) {
          changedProperties[currentPath] = { ...nestedChanges, id: objB.id };
        }
      } else if (objA[key] !== objB[key]) {
        // If values are different, record the change
        changedProperties[key] = objB[key];
      }
    } else {
      // If key does not exist in objB, record as deleted
      changedProperties[currentPath] = undefined;
    }
  });

  // Check keys in objB to find added properties
  Object.keys(objB || {}).forEach(key => {
    const currentPath = key;

    // If key does not exist in objA, record as added
    if (!objA.hasOwnProperty(key)) changedProperties[currentPath] = objB[key];
  });

  return changedProperties;
};

const StoreDashboardCards = ({ title, value, isValidData }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));

  const cardWidth = isLargeScreen ? 280 : 220;

  return (
    <Card className={classes.storeCard} style={{ width: cardWidth }}>
      <CardContent style={{ padding: 0 }}>
        <Typography variant="body2MediumInter" className={classes.storeCardTitel} gutterBottom>
          {title}
        </Typography>
        <Typography variant="h3BoldInter" className={classes.storeCardData}>
          {isValidData ? value : '-'}
        </Typography>
      </CardContent>
    </Card>
  );
};

const productsCustomFilter = (summary, collectionOnly, uniqueUrl) => {
  const statuses = [];
  // switch (true) {
  //   case !collectionOnly && uniqueUrl:
  //     statuses = ['Declined', ...shipmentAPIStatuses];
  //     break;
  //   case !collectionOnly && !uniqueUrl:
  //     statuses = shipmentAPIStatuses;
  //     break;
  //   case collectionOnly && uniqueUrl:
  //     statuses = storefrontStatuses;
  //     break;
  //   default:
  //     statuses = ['Ordered'];
  // }
  return summary
    ? [
        {
          name: 'shipment_status',
          label: 'Status',
          behavior: 'multiselect',
          options: statuses.reduce((sum, s) => ({ ...sum, [s]: s }), {})
        },
        {
          name: 'item',
          label: 'Product Selected',
          behavior: 'multiselect',
          options: summary.selectedProducts.reduce((sum, p) => ({ ...sum, [p.productId]: p.name }), {})
        }
      ].filter(f => !isEmpty(f.options))
    : undefined;
};

const MarginInputField = ({ adornmentPosition, adornmentValue, disabled }) => {
  const classes = useStyles();

  return (
    <TextField
      variant="outlined"
      defaultValue={0}
      InputProps={{
        startAdornment: (
          <InputAdornment position={adornmentPosition}>
            <Typography variant="body3SemiBoldInter" style={{ color: disabled ? '#989EA4' : '#374151' }}>
              {adornmentValue}
            </Typography>
          </InputAdornment>
        )
      }}
      className={classes.marginField}
      disabled={disabled}
    />
  );
};

const SwagupRates = () => {
  const classes = useStyles();
  const [toggle, setToggle] = React.useState({
    checkedA: true
  });

  const handleChange = event => {
    setToggle({ ...toggle, [event.target.name]: event.target.checked });
  };

  return (
    <Grid container className={classes.mainContainer}>
      <Grid className={classes.swagupRates}>
        <GreenAntSwitch checked={toggle.checkedA} onChange={handleChange} name="checkedA" />
        <Typography variant="body3RegularInter">Add a a margin on top of our rates</Typography>
      </Grid>
      <MarginInputField adornmentPosition="start" adornmentValue="%" disabled={!toggle.checkedA} />
    </Grid>
  );
};

const ShippingOption = ({ shippingType, shippingDays, onToggleChange }) => {
  const classes = useStyles();

  const [isFree, setIsFree] = useState(false);
  const [price, setPrice] = useState();

  const [toggle, setToggle] = React.useState({
    checkedA: true
  });

  const handleChange = event => {
    setToggle({ ...toggle, [event.target.name]: event.target.checked });
  };

  const handleFreeCheckboxChange = event => {
    onToggleChange(event.target.checked);
    if (!toggle.checkedA) {
      setIsFree(false);
      setToggle({ checkedA: false });
      setPrice('');
    } else {
      setIsFree(!isFree);
      if (!isFree) {
        setPrice('');
      }
    }
  };

  return (
    <Grid container spacing={2} className={isFree ? classes.shippingOption : classes.disabledShippingOption}>
      <Grid item>
        <GreenAntSwitch checked={toggle.checkedA} onChange={handleChange} name="checkedA" />
      </Grid>
      <Grid item style={{ width: '140px', textAlign: 'flex-start' }}>
        <Typography variant="body3MediumInter" style={{ color: '#4A4F54' }}>
          {shippingType}
        </Typography>
        <Typography variant="body4RegularInter" style={{ color: '#4A4F54' }}>
          {shippingDays}
        </Typography>
      </Grid>
      <Grid item style={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          icon={<CheckBoxOutlineBlankIcon fontSize="small" style={{ color: '#D6D8DB' }} />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          checked={isFree}
          onChange={handleFreeCheckboxChange}
          style={{
            color: '#3577D4'
          }}
          disabled={!toggle.checkedA}
        />
        <Typography variant="body3MediumInter" style={{ color: '#4A4F54' }}>
          Free
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body3MediumInter" style={{ color: '#4A4F54' }}>
          or
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body4RegularInter" style={{ color: isFree ? '#989EA4' : '#4A4F54', paddingBottom: 4 }}>
          Select Price
        </Typography>
        <TextField
          variant="outlined"
          value={Number(price)}
          onChange={e => setPrice(e.target.value)}
          className={classes.selectPrice}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography
                  variant="body3SemiBoldInter"
                  style={{ color: !toggle.checkedA || isFree ? '#989EA4' : '#374151' }}
                >
                  $
                </Typography>
              </InputAdornment>
            ),
            disabled: !toggle.checkedA || isFree
          }}
          inputProps={{
            type: 'number',
            step: 'any'
          }}
        />
      </Grid>
    </Grid>
  );
};

const CustomRates = () => {
  const classes = useStyles();

  const [shippingOptions, setShippingOptions] = useState([
    { id: 1, shippingType: 'Standard Shipping', shippingDays: '19 Business Days', isFree: false, price: 5 },
    { id: 2, shippingType: 'Rush Shipping', shippingDays: '17 Business Days', isFree: false, price: 5 },
    { id: 3, shippingType: 'Standard Shipping', shippingDays: '19 Business Days', isFree: false, price: 5 },
    { id: 4, shippingType: 'Rush Shipping', shippingDays: '17 Business Days', isFree: false, price: 5 }
  ]);

  const USOptions = shippingOptions.slice(0, 2);
  const InternationalOptions = shippingOptions.slice(2);

  const chargeSwagupRates = shippingOptions.some(option => option?.isFree);

  const handleToggleChange = (isChecked, optionId) => {
    setShippingOptions(prevOptions => {
      return prevOptions.map(option => {
        if (option.id === optionId) {
          return { ...option, isFree: isChecked };
        }
        return option;
      });
    });
  };

  return (
    <Grid container className={classes.mainContainer}>
      <Typography variant="body3SemiBoldInter">US only</Typography>
      <Divider orientation="horizontal" style={{ width: '100%' }} />
      {USOptions.map(option => (
        <ShippingOption
          key={option.id}
          shippingType={option.shippingType}
          shippingDays={option.shippingDays}
          onToggleChange={isChecked => handleToggleChange(isChecked, option.id)}
        />
      ))}
      <Typography variant="body3SemiBoldInter">International</Typography>
      <Divider orientation="horizontal" style={{ width: '100%' }} />
      {InternationalOptions.map(option => (
        <ShippingOption
          key={option.id}
          shippingType={option.shippingType}
          shippingDays={option.shippingDays}
          onToggleChange={isChecked => handleToggleChange(isChecked, option.id)}
        />
      ))}
      {chargeSwagupRates && (
        <Grid container>
          <RouterLink to="#">
            <Typography variant="body4RegularInter" style={{ color: '#3577D4' }}>
              You will be charged SwagUp rates, regardless.
            </Typography>
          </RouterLink>
        </Grid>
      )}
    </Grid>
  );
};

const SettingToggleBtn = ({ firstButtonText, secondButtonText, buttonWidth, onToggle, selectedOption }) => {
  const classes = useStyles();

  const handleToggle = option => {
    onToggle(option);
  };

  return (
    <>
      <ButtonGroup
        style={{
          boxShadow: 'none !important'
        }}
      >
        <Button
          variant="primary"
          style={{
            backgroundColor: selectedOption === firstButtonText ? '#4CAF50' : 'white',
            borderRadius: '100px 0px 0px 100px',
            width: buttonWidth
          }}
          onClick={() => handleToggle(firstButtonText)}
          className={classes.toggleBtn}
        >
          <Typography
            variant="body3SemiBoldInter"
            style={{
              color: selectedOption === firstButtonText ? 'white' : 'black'
            }}
            className={classes.toggleBtnSelected}
          >
            {selectedOption === firstButtonText && <DoneIcon />} {firstButtonText}
          </Typography>
        </Button>
        <Button
          variant="primary"
          style={{
            backgroundColor: selectedOption === secondButtonText ? '#4CAF50' : 'white',
            borderRadius: '0px 100px 100px 0px',
            width: buttonWidth
          }}
          onClick={() => handleToggle(secondButtonText)}
          className={classes.toggleBtn}
        >
          <Typography
            variant="body3SemiBoldInter"
            style={{
              color: selectedOption === secondButtonText ? 'White' : 'black'
            }}
            className={classes.toggleBtnSelected}
          >
            {selectedOption === secondButtonText && <DoneIcon />} {secondButtonText}
          </Typography>
        </Button>
      </ButtonGroup>
    </>
  );
};

const DeleteProductOptionModal = ({ open, onClose, onDelete }) => {
  const classes = useStyles();
  return (
    <SharedModal open={open} onClose={onClose} classes={{ paper: classes.confirmModal }}>
      <Box className={classes.shareModalContent}>
        <Box className={classes.confirmModalMain}>
          <Box>
            <Typography variant="h6SemiBoldInter" className={classes.confirmModalTitle}>
              Are you sure want to remove this product?
            </Typography>
          </Box>
          <Grid container justifyContent="center" alignItems="center" spacing={4}>
            <Grid item>
              <Button size="small" variant="primary" onClick={onDelete} style={{ height: 40 }}>
                Remove Product
              </Button>
            </Grid>
          </Grid>
          <Grid container justifyContent="center" alignItems="center" spacing={4}>
            <Grid item>
              <Button variant="text" size="small" onClick={onClose} style={{ height: 40 }}>
                Keep Product
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </SharedModal>
  );
};

export {
  StorefrontCard,
  PresetTemplate,
  ProductCard,
  getPageLink,
  prepare,
  prepareArtworksOnS3,
  FileUploadZone,
  OrderRow,
  TableEmptyState,
  StorefrontDeleteModal,
  ColorInput,
  RedeemCustomSelectField,
  ImageUploadSection,
  getStatus,
  ImageSelector,
  CreateRedeemOptionsDrawer,
  ProductsSelectionPanel,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  CustomTextField,
  NumberFormatCustom,
  PageRedemptionsBlock,
  PageInventoryBlock,
  AvailableCreditBlock,
  ShareStatusBlock,
  TableHeaderCollection,
  TableHeaderOrder,
  getShippingStatus,
  shipmentStatuses,
  RedemptionDeleteModal,
  useModalStyles,
  Notification,
  getStatusAllowed,
  CustomSlimTextField,
  getChangedProperties,
  StoreDashboardCards,
  productsCustomFilter,
  TableHeaderProduct,
  ProductOptionRow,
  SettingToggleBtn,
  SwagupRates,
  CustomRates,
  CustomerRow,
  TableHeaderCustomer,
  PayoutRow,
  TableHeaderPayout,
  CustomSlimTextFieldThin,
  GreenAntSwitch,
  DeleteProductOptionModal
};
